import React from "react";
import { IconType } from "react-icons";

import {
  MdSecurity,
  MdVideocam,
  MdFingerprint,
  MdPhone,
  MdVideoCameraFront,
  MdLock,
  MdFireExtinguisher,
  MdNotificationsActive,
  MdBadge,
  MdSmartphone,
  MdLocalParking,
  MdEvStation,
  MdPedalBike,
  MdDirectionsBus,
  MdLocalCarWash,
  MdDirectionsWalk,
  MdDirectionsRun,
  MdDirectionsBike,
  MdPets,
  MdGrass,
  MdPark,
  MdNaturePeople,
  MdPool,
  MdHome,
  MdCelebration,
  MdTheaters,
  MdOutdoorGrill,
  MdGroups,
  MdRoofing,
  MdDinnerDining,
  MdFitnessCenter,
  MdSelfImprovement,
  MdSpa,
  MdHotTub,
  MdHealthAndSafety,
  MdSportsBasketball,
  MdSportsTennis,
  MdSportsVolleyball,
  MdSportsSoccer,
  MdIceSkating,
  MdGolfCourse,
  MdChildCare,
  MdChildFriendly,
  MdColorLens,
  MdExplore,
  MdElderly,
  MdFamilyRestroom,
  MdBusiness,
  MdWifi,
  MdLocalCafe,
  MdStorefront,
  MdLocalAtm,
  MdMeetingRoom,
  MdLaptop,
  MdShoppingCart,
  MdAccountBalance,
  MdKitchen,
  MdBalcony,
  MdElevator,
  MdAcUnit,
  MdPhoneIphone,
  MdStar,
  MdWindow,
  MdSolarPower,
  MdWaterDrop,
  MdRecycling,
  MdLightbulb,
  MdWater,
  MdPlumbing,
  MdNature,
  MdEco,
  MdVerified,
  MdCarRental,
  MdDirectionsCar,
} from "react-icons/md";

import { GiCricketBat, GiMeditation } from "react-icons/gi";

const SLUG_ICON_MAP: Record<string, IconType> = {
  // Security
  "24x7-security":            MdSecurity,
  "cctv-surveillance":        MdVideocam,
  "biometric-access":         MdFingerprint,
  "intercom-facility":        MdPhone,
  "video-door-phone":         MdVideoCameraFront,
  "gated-community":          MdLock,
  "fire-safety-system":       MdFireExtinguisher,
  "alarm-system":             MdNotificationsActive,
  "visitor-management":       MdBadge,
  "smart-security-app":       MdSmartphone,
  // Mobility
  "covered-parking":          MdLocalParking,
  "ev-charging-station":      MdEvStation,
  "visitor-parking":          MdDirectionsCar,
  "basement-parking":         MdLocalParking,
  "multi-level-parking":      MdLocalParking,
  "bicycle-parking":          MdPedalBike,
  "internal-roads":           MdDirectionsCar,
  "shuttle-service":          MdDirectionsBus,
  "car-wash-area":            MdLocalCarWash,
  "valet-parking":            MdCarRental,
  // Outdoor
  "landscaped-garden":        MdNaturePeople,
  "central-park":             MdPark,
  "walking-track":            MdDirectionsWalk,
  "jogging-track":            MdDirectionsRun,
  "cycling-track":            MdDirectionsBike,
  "water-fountain":           MdWater,
  "zen-garden":               MdSpa,
  "pet-park":                 MdPets,
  "open-lawn":                MdGrass,
  "tree-avenue":              MdNature,
  // Recreation
  "swimming-pool":            MdPool,
  "kids-pool":                MdPool,
  "infinity-pool":            MdPool,
  "clubhouse":                MdHome,
  "party-hall":               MdCelebration,
  "banquet-hall":             MdDinnerDining,
  "amphitheatre":             MdTheaters,
  "bbq-area":                 MdOutdoorGrill,
  "rooftop-lounge":           MdRoofing,
  "community-lounge":         MdGroups,
  // Fitness
  "gymnasium":                MdFitnessCenter,
  "yoga-room":                MdSelfImprovement,
  "meditation-zone":          GiMeditation,
  "aerobics-room":            MdDirectionsRun,
  "spa":                      MdSpa,
  "sauna":                    MdHotTub,
  "steam-room":               MdHotTub,
  "wellness-center":          MdHealthAndSafety,
  "open-gym":                 MdFitnessCenter,
  "reflexology-path":         MdDirectionsWalk,
  // Sports
  "cricket-pitch":            GiCricketBat,
  "basketball-court":         MdSportsBasketball,
  "tennis-court":             MdSportsTennis,
  "badminton-court":          MdSportsTennis,
  "volleyball-court":         MdSportsVolleyball,
  "football-ground":          MdSportsSoccer,
  "skating-rink":             MdIceSkating,
  "table-tennis":             MdSportsTennis,
  "indoor-games":             MdSportsBasketball,
  "golf-area":                MdGolfCourse,
  // Kids
  "kids-play-area":           MdChildCare,
  "toddler-zone":             MdChildFriendly,
  "daycare-center":           MdChildCare,
  "kids-activity-room":       MdColorLens,
  "sand-pit":                 MdChildCare,
  "adventure-zone":           MdExplore,
  "senior-citizen-area":      MdElderly,
  "family-zone":              MdFamilyRestroom,
  "slides":                   MdChildFriendly,
  "swing-area":               MdChildCare,
  // Commercial
  "office-space":             MdBusiness,
  "high-speed-wifi":          MdWifi,
  "cafe":                     MdLocalCafe,
  "retail-shops":             MdStorefront,
  "atm":                      MdLocalAtm,
  "meeting-rooms":            MdMeetingRoom,
  "conference-room":          MdMeetingRoom,
  "co-working-space":         MdLaptop,
  "shopping-zone":            MdShoppingCart,
  "banking-facility":         MdAccountBalance,
  // Home
  "modular-kitchen":          MdKitchen,
  "balcony":                  MdBalcony,
  "elevator":                 MdElevator,
  "power-backup":             MdEvStation,
  "air-conditioning":         MdAcUnit,
  "smart-home":               MdSmartphone,
  "mobile-app-control":       MdPhoneIphone,
  "premium-fittings":         MdStar,
  "main-door-security":       MdLock,
  "large-windows":            MdWindow,
  // Sustainability
  "solar-panels":             MdSolarPower,
  "rainwater-harvesting":     MdWaterDrop,
  "recycling-system":         MdRecycling,
  "waste-management":         MdRecycling,
  "energy-efficient-lighting": MdLightbulb,
  "water-conservation":       MdWater,
  "sewage-treatment-plant":   MdPlumbing,
  "organic-farming":          MdNature,
  "green-landscaping":        MdEco,
  "green-building-certified": MdVerified,
};

const FALLBACK: IconType = MdSecurity;

export const getAmenityIcon = (
  slug: string,
  className = "w-6 h-6",
): React.ReactElement => {
  const normalised = (slug || "").toLowerCase().replace(/\s+/g, "-");
  const Icon = SLUG_ICON_MAP[normalised] || FALLBACK;
  return <Icon className={className} />;
};
